import { useCallback } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function ReviewSelectInput({
  disabled,
  fieldKey,
  label,
  multi,
  options,
  placeholder,
  tooltip
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review
  } = useReviewContext();
  const {
    locked,
    required,
    minSelected,
    maxSelected
  } = getFieldValidation('tags', fieldKey);
  const defaultValue = multi ? review.tags[fieldKey] : review.tags[fieldKey] ? review.tags[fieldKey][0] : null;
  let formattedOptions = options;
  if (maxSelected && review.tags[fieldKey]) {
    formattedOptions = options.map(option => Object.assign({}, option, {
      disabled: !maxSelected || review.tags[fieldKey].length >= maxSelected
    }));
  }
  let validationMessage;
  if (minSelected && review.tags[fieldKey] && review.tags[fieldKey].length !== 0 && review.tags[fieldKey].length < minSelected) {
    validationMessage = unescapedText('trellisEcosystem.reviews.minimumTags', {
      minSelected
    });
  }
  const handleUpdateReview = useCallback(({
    target: {
      value
    }
  }) => onUpdateReview({
    tags: {
      [fieldKey]: value
    }
  }), [fieldKey, onUpdateReview]);
  return /*#__PURE__*/_jsx(FormControl, {
    error: !!validationMessage,
    label: label,
    required: !!minSelected || required,
    tooltip: tooltip,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(TFlex, {
      direction: "row",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(Select, {
        defaultValue: defaultValue,
        disabled: disabled || locked,
        error: !!validationMessage,
        multi: multi,
        onChange: handleUpdateReview,
        options: formattedOptions,
        placeholder: placeholder
      })
    })
  });
}